module.exports = __webpack_public_path__ + "img/am02.58bd98fc.jpg";